export default __webpack_public_path__ + "static/media/web-apps.19c15596.svg";